; (function () {
	const MOBILE_MAX = 576

	const initOrDestroyForSection = ($section) => {
		const id = $section.attr('id')
		const $box = $section.find('.card-list')

		if ($box.find('.swiper').length === 0) return

		const isMobile = window.innerWidth <= MOBILE_MAX
		const initialized = Boolean($box.data('swiper-initialized'))

		if (isMobile) {
			if (initialized) return

			$section.find('.card-list__list li').each(function () {
				const $li = $(this)
				if (!$li.hasClass('swiper-slide')) {
					$li.addClass('swiper-slide')
				}
			})

			const autoplay = $box.data('autoplay')
			const stopAutoplay = $box.data('stop-autoplay')
			const delay = 4 * 1000
			const rawColumnsMobile = $box.data('columns-mobile')
			let columnsMobile = Math.max(1, parseInt(String(rawColumnsMobile), 10) || 0)

			const slidesCount = $section.find('.card-list__list li').length

			if (slidesCount > columnsMobile) {
				columnsMobile += 0.12
			}

			let autoplayParm = {}
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				}
			}

			const swiperParms = {
				slidesPerView: columnsMobile,
				loop: false,
				spaceBetween: 12,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
					type: 'bullets',
				},
				...autoplayParm,
			}

			const swiperInstance = new Swiper(`#${id} .swiper`, swiperParms)
			$box.data('swiper-initialized', true)
			$box.data('swiper-instance', swiperInstance)
		} else {
			if (!initialized) {
				$section.find('.card-list__list .swiper-slide').removeClass('swiper-slide')
				return
			}

			const swiperInstance = $box.data('swiper-instance')
			if (swiperInstance && typeof swiperInstance.destroy === 'function') {
				try {
					swiperInstance.destroy(true, true)
				} catch (e) { }
			}
			$box.removeData('swiper-instance')
			$box.removeData('swiper-initialized')
			$section.find('.card-list__list .swiper-slide').removeClass('swiper-slide')
		}
	}

	const syncAllSections = () => {
		$('.card-list-section').each(function () {
			initOrDestroyForSection($(this))
		})
	}

	let resizeTimer = null
	const onResize = () => {
		if (resizeTimer) clearTimeout(resizeTimer)
		resizeTimer = setTimeout(() => {
			resizeTimer = null
			syncAllSections()
		}, 150)
	}

	document.addEventListener('DOMContentLoaded', function () {
		syncAllSections()
		window.addEventListener('resize', onResize)

		document.addEventListener('shopify:section:load', function (e) {
			const sectionId = e && e.detail && e.detail.sectionId ? `shopify-section-${e.detail.sectionId}` : null
			if (!sectionId) return
			const $section = $(`#${sectionId}`)
			if ($section.length) initOrDestroyForSection($section)
		})

		document.addEventListener('shopify:section:unload', function (e) {
			const sectionId = e && e.detail && e.detail.sectionId ? `shopify-section-${e.detail.sectionId}` : null
			if (!sectionId) return
			const $section = $(`#${sectionId}`)
			if ($section.length) initOrDestroyForSection($section)
		})
	})
})()
